/**
 * @desc 处理事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  data: defs.TheNewEventProcessingParameters,
  params: Params,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/event/{id}/execute',
    data,
    params,
  });
}

export function mock(
  data: defs.TheNewEventProcessingParameters,
  params: Params,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/event/{id}/execute',
    data,
    params,
  });
}
